import { z } from 'zod';
import { IdSchema } from '../common/base.schema';

/**
 * Subscription Schemas
 *
 * Genie uses a wallet-based billing model — NO plan tiers.
 * Subscriptions are "recurring top-ups": a monthly charge that adds
 * credits to the user's wallet. Everyone gets the same features.
 */

// Subscription Status Enum
export const SubscriptionStatusSchema = z.enum(['ACTIVE', 'CANCELED', 'PAST_DUE', 'UNPAID', 'INCOMPLETE'], {
  error: "Invalid subscription status"
});

// Subscription Schema — represents a recurring top-up, NOT a plan tier
export const SubscriptionSchema = z.object({
  id: IdSchema,
  status: SubscriptionStatusSchema,
  /** Monthly recurring top-up amount in USD cents (e.g. 2500 = $25/mo) */
  recurringAmount: z.number().int().min(0).default(0),
  stripeCustomerId: z.string().optional(),
  stripeSubscriptionId: z.string().optional(),
  stripePriceId: z.string().optional(),
  currentPeriodStart: z.date().optional(),
  currentPeriodEnd: z.date().optional(),
  cancelAtPeriodEnd: z.boolean().default(false),
  createdAt: z.date(),
  updatedAt: z.date(),
  userId: IdSchema
});

// Export TypeScript types
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;
export type Subscription = z.infer<typeof SubscriptionSchema>;